/**
 * custom-clube.js
 * Shared JS module for LP v2 (page.clube). Loaded defer via custom.globals.liquid.
 * Budget: ≤12KB gzipped total.
 */
(function () {
  'use strict';

  /* ---------- Sticky CTA (pill desktop / bar mobile) ---------- */
  var stickyCta = document.querySelector('[data-urs-sticky-cta]');
  var heroAnchor = document.getElementById('urs-hero-club-anchor');

  if (stickyCta && heroAnchor) {
    var stickyObs = new IntersectionObserver(function (entries) {
      var isHeroVisible = entries[0].isIntersecting;
      stickyCta.classList.toggle('urs-sticky-cta--visible', !isHeroVisible);
      stickyCta.setAttribute('aria-hidden', isHeroVisible ? 'true' : 'false');
      if (isHeroVisible) {
        stickyCta.setAttribute('inert', '');
      } else {
        stickyCta.removeAttribute('inert');
      }
    }, { threshold: 0 });
    stickyObs.observe(heroAnchor);
  }


  /* ---------- Fade-up on scroll (shared IntersectionObserver) ---------- */
  var fadeEls = document.querySelectorAll('[data-urs-fade-up]');
  if (fadeEls.length > 0) {
    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('urs-fade-up--visible');
          fadeObs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-10%', threshold: 0 });

    fadeEls.forEach(function (el) { fadeObs.observe(el); });
  }

  /* ---------- Follow button (localStorage toggle) ---------- */
  var followBtn = document.querySelector('[data-urs-follow-btn]');
  if (followBtn) {
    var FOLLOW_KEY = 'urs-following';
    var isFollowing = localStorage.getItem(FOLLOW_KEY) === 'true';

    function updateFollowState(state) {
      followBtn.setAttribute('aria-pressed', state ? 'true' : 'false');
      localStorage.setItem(FOLLOW_KEY, state ? 'true' : 'false');
    }

    if (isFollowing) updateFollowState(true);

    followBtn.addEventListener('click', function () {
      var current = followBtn.getAttribute('aria-pressed') === 'true';
      updateFollowState(!current);
    });
  }

  /* ---------- Album rail mouse drag-to-scroll ---------- */
  var scrollers = document.querySelectorAll('.urs-album-rail__scroller, .urs-top-tracks__scroller, .urs-member-catalog__scroll, .urs-dash__rail-scroll');
  scrollers.forEach(function (scroller) {
    var isDown = false;
    var startX;
    var scrollLeft;
    var hasDragged = false;

    scroller.addEventListener('mousedown', function (e) {
      isDown = true;
      hasDragged = false;
      scroller.classList.add('urs-grabbing');
      startX = e.pageX - scroller.offsetLeft;
      scrollLeft = scroller.scrollLeft;
    });

    scroller.addEventListener('mouseleave', function () {
      isDown = false;
      scroller.classList.remove('urs-grabbing');
    });

    scroller.addEventListener('mouseup', function () {
      isDown = false;
      scroller.classList.remove('urs-grabbing');
    });

    scroller.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      hasDragged = true;
      var x = e.pageX - scroller.offsetLeft;
      var walk = (x - startX) * 1.5;
      scroller.scrollLeft = scrollLeft - walk;
    });

    scroller.addEventListener('click', function (e) {
      if (hasDragged) e.preventDefault();
    }, true);
  });

  /* ---------- Preview player (skeleton — no audio source yet) ---------- */
  var previewPlayer = document.querySelector('[data-urs-preview-player]');
  if (previewPlayer) {
    var closeBtn = previewPlayer.querySelector('[data-urs-preview-close]');

    window.URS = window.URS || {};
    window.URS.showPreview = function (title) {
      var titleEl = previewPlayer.querySelector('[data-urs-preview-title]');
      if (titleEl) titleEl.textContent = title || '—';
      previewPlayer.hidden = false;
      previewPlayer.setAttribute('data-urs-player-visible', '');
    };

    window.URS.hidePreview = function () {
      previewPlayer.removeAttribute('data-urs-player-visible');
      setTimeout(function () { previewPlayer.hidden = true; }, 350);
    };

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        window.URS.hidePreview();
      });
    }
  }
  /* ---------- GSAP ScrollTrigger — premium scroll animations ---------- */
  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('[data-urs-fade-up]').forEach(function (el) {
      gsap.from(el, {
        y: 40,
        opacity: 0,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          once: true
        }
      });
    });


    var headline = document.querySelector('.urs-hero__headline');
    if (headline) {
      var text = headline.innerHTML;
      var words = text.split(/(\s+|<br\s*\/?>)/);
      headline.innerHTML = words.map(function (w) {
        if (/^\s+$/.test(w) || /^<br/.test(w)) return w;
        return '<span class="urs-word-reveal" style="display:inline-block;opacity:0">' + w + '</span>';
      }).join('');

      gsap.to('.urs-word-reveal', {
        opacity: 1,
        y: 0,
        duration: 0.4,
        stagger: 0.08,
        ease: 'power2.out',
        delay: 0.3
      });
    }

    var tierCards = document.querySelectorAll('.urs-tier-card');
    if (tierCards.length > 0) {
      gsap.from(tierCards, {
        y: 60,
        opacity: 0,
        duration: 0.7,
        stagger: 0.15,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: tierCards[0].parentElement,
          start: 'top 80%',
          once: true
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initGSAP, 100);
    });
  } else {
    setTimeout(initGSAP, 100);
  }
})();

/* ---------- Member dashboard sidebar nav ---------- */
(function() {
  var navItems = document.querySelectorAll('[data-urs-dash-nav]');
  if (!navItems.length) return;

  var sections = {
    home: ['.urs-dash__welcome', '.urs-dash__spotlight'],
    catalog: ['.urs-dash__rail'],
    downloads: ['.urs-dash__rail'],
    membership: ['.urs-dash__perks']
  };

  navItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      var target = item.getAttribute('data-urs-dash-nav');

      navItems.forEach(function(n) { n.classList.remove('urs-dash__nav-item--active'); });
      item.classList.add('urs-dash__nav-item--active');

      var selectors = sections[target];
      if (selectors && selectors.length) {
        var el = document.querySelector(selectors[0]);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
